import React from 'react'

const PayrollAnalytics = () => {
  return (
    <div>PayrollAnalytics</div>
  )
}

export default PayrollAnalytics